module.exports = __webpack_public_path__ + "static/media/title_white.49782deb.png";